import { FRAuth, FRUser, TokenManager, Config } from '@forgerock/javascript-sdk'
import { ERROR_MESSAGES, getPassFailedMessage } from './errorMessages'
import { loginOnNewAuth } from './loginOnNewAuth'
import { eventDataLayer } from '../commons/utils'

export const loginOnReact = (username, password, dispatch) => {
  const FATAL = 'Fatal'
  const BASEURL = process.env.REACT_APP_FR_BASE_URL
  const REDIRECTURI = process.env.REACT_APP_FR_SUCCESS_CALLBACK
  const TREENAME = process.env.REACT_APP_FR_LOGIN_TREENAME
  // id del blocco popup
  const LOGINBLOCKCONTAINER = '#a2a-login-block-login'
  // id del pulsante click
  const LOGINBUTTONCLASS = '.login-action'
  const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  window.stepBackup = null

  // Set OtpState
  window.userOtpTried = false

  Config.set({
    clientId: 'AENDrupalClient', // e.g. 'ForgeRockSDKClient'
    redirectUri: REDIRECTURI, // e.g. 'https://sdkapp.example.com:8443/_callback'
    scope: 'openid profile email', // e.g. 'openid profile me.read'
    serverConfig: {
      baseUrl: BASEURL, // e.g. 'https://openam.example.com:9443/openam/'
      timeout: 90000, // 90000 or less
    },
    realmPath: 'AENMobile', // e.g. 'root'
    tree: TREENAME, // e.g. 'Login'
    tokenStore: 'sessionStorage',
  })

  const showUser = (user) => {
    document.querySelector('#User pre').innerHTML = JSON.stringify(
      user,
      null,
      2
    )
    const panel = document.querySelector('#User')
    panel.querySelector('.btnhidden').addEventListener('click', () => {
      logout()
    })
    showStep('User')
  }

  // Show only the view for this handler
  const showStep = (handler) => {
    return true
  }

  const resetOtpErrors = () => {
    try {
      window.userOtpTried = false
      document.querySelector('#otp-error').classList.remove('visible')
      document.querySelector('#otp-error span').innerHTML = ''
      document
        .querySelectorAll('input')
        .forEach((input) => input.classList.remove('error'))
    } catch (error) {}
  }

  const handlersLogin = {
    UsernamePassword: (step) => {
      const panel = document.querySelector('#UsernamePassword')
      panel.querySelector('.btnhidden').addEventListener('click', () => {
        //Raf: retrieve delle callback necessarie
        const nameCallback = step.getCallbackOfType('NameCallback')
        const passwordCallback = step.getCallbackOfType('PasswordCallback')
        //Raf: ad ogni callback associo l'elemento del DOM
        if (1) {
          nameCallback.setName(username.toLowerCase())
        } else {
          nameCallback.setName(username)
        }
        passwordCallback.setPassword(password)
        nextStep(step)
      })
    },
    StringAttributeInputCallback: (step) => {
      const StringAttributeInputCallback = step.getCallbackOfType(
        'StringAttributeInputCallback'
      )
      StringAttributeInputCallback.setValue('WEB')
      nextStep(step)
    },
    StringAttributeInputCallbackRecaptcha: (step) => {
      const RecaptchaCallback = step.getCallbackOfType('ReCaptchaCallback')
      const siteKey = RecaptchaCallback.getSiteKey()
      const captchaApiUri =
        RecaptchaCallback.getOutputByName('captchaApiUri') +
        '?render=' +
        siteKey
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.onload = function () {
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function () {
          // eslint-disable-next-line no-undef
          grecaptcha
            .execute(siteKey, { action: 'submit' })
            .then(function (token) {
              RecaptchaCallback.setResult(token)
              const StringAttributeInputCallback = step.getCallbackOfType(
                'StringAttributeInputCallback'
              )
              StringAttributeInputCallback.setValue('WEB')
              nextStep(step)
            })
        })
      }
      script.src = captchaApiUri
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    MigrationError4: (step) => {
      console.log('SAP_MIGRATION_ERROR')
      console.log(step)
      document.querySelector('#loader-scripts').classList.remove('visible')
      document.querySelector('#Error').classList.add('visible')
      document.querySelector('#Error span').innerHTML =
        "Per poter accedere all'Area Clienti, solo per questa volta, è necessario impostare una nuova password. Clicca su" +
        ` <a href='${process.env.REACT_APP_A2A_URL}/reset-password?password=1'>Hai dimenticato la password</a>` +
        ' per effettuare la modifica.'
    },
    OtpEmailInner: (step) => {
      window.stepBackup = step

      const panelNormal = document.getElementById('form-login')
      const panel = document.getElementById('form-login-otp')
      const otpBtn = document.getElementById('otp-btn')
      const label = document.getElementById('form-label')
      const socialContainer = document.getElementById('form-social-container')
      const resendOTPBtn = document.getElementById('resend-otp')
      const errorField = document.querySelector('#otp-error')
      const errorFieldSpan = document.querySelector('#otp-error span')
      let inputs = document.querySelectorAll('input')
      inputs.forEach((input) => input.classList.remove('error'))
      if (panel.classList.contains('visible') && window.userOtpTried) {
        // OTP tried but error received
        errorField.classList.add('visible')
        errorFieldSpan.innerHTML =
          'Il codice inserito non è corretto. Te ne abbiamo inviato uno nuovo, inseriscilo e prosegui.'
        inputs.forEach((input) => input.classList.add('error'))
        document.getElementById('otp-input').value = ''
      } else if (panel.classList.contains('visible') && !window.userOtpTried) {
        // New OTP sent
        errorField.classList.add('visible')
        errorFieldSpan.innerHTML =
          'Ti abbiamo inviato un nuovo codice OTP, inseriscilo e prosegui.'
        document.getElementById('otp-input').value = ''
      }

      console.log('OTPEMAIL')
      panelNormal.classList.add('hidden')
      label.classList.add('hidden')
      socialContainer.classList.add('hidden')
      errorField.classList.add('hidden')
      panel.classList.add('visible')
      resendOTPBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation()
        resetOtpErrors()
        let value = '000000'
        const passwordCallback =
          window.stepBackup.getCallbackOfType('PasswordCallback')
        passwordCallback.setPassword(value)
        nextStep(window.stepBackup)
      })
      otpBtn.addEventListener('click', (e) => {
        e.stopImmediatePropagation()
        resetOtpErrors()
        let value = document.getElementById('otp-input').value
        if (!value || value.length < 6) {
          errorField.classList.add('visible')
          errorFieldSpan.innerHTML = 'Inserisci nuovamente otp mail'
          document.getElementById('otp-input').value = ''
        } else {
          window.userOtpTried = true
          const passwordCallback =
            window.stepBackup.getCallbackOfType('PasswordCallback')
          passwordCallback.setPassword(value)
          document.querySelector('#loader-scripts').classList.add('visible')
          nextStep(window.stepBackup)
        }
      })
      document.querySelector('#loader-scripts').classList.remove('visible')
    },
    Step5PasswordInner: (step) => {
      window.stepBackup = step
      const panelNormal = document.getElementById('form-login')
      const registratiFooter = document.getElementById('registrati-footer')
      const panel = document.getElementById('form-login-password')
      const passwordBtn = document.getElementById('password-btn')
      const accediBtn = document.getElementById('password-btn-accedi')
      const passwordContent = panel?.querySelector('.reset-password-wrapper')
      const passwordTyp = panel?.querySelector('.reset-password-typ')
      const label = document.getElementById('form-label')
      const socialContainer = document.getElementById('form-social-container')
      const errorField = document.querySelector('#password-error')
      const errorFieldSpan = document.querySelector('#password-error span')
      let inputs = document.querySelectorAll('input')
      inputs.forEach((input) => input.classList.remove('error'))

      console.log('step5passwordinner')
      console.log(window.stepBackup)
      panelNormal.classList.add('hidden')
      label.classList.add('hidden')
      socialContainer.classList.add('hidden')
      errorField.classList.add('hidden')
      panel.classList.add('visible')

      passwordBtn.addEventListener('click', () => {
        let value = document.getElementById('password-input').value
        let valueConfirm = document.getElementById(
          'password-input-confirm'
        ).value
        if (!value || value.length === 0) {
          errorField.classList.add('visible')
          errorFieldSpan.innerHTML = 'Campo obbligatorio'
          inputs.forEach((input) => input.classList.add('error'))
        } else if (value !== valueConfirm) {
          errorField.classList.add('visible')
          errorFieldSpan.innerHTML =
            'Le password non coincidono. Controlla i campi e continua'
          inputs.forEach((input) => input.classList.add('error'))
        } else {
          if (!document.body.classList.contains('pwd-success-temp')) {
            const passwordCallback = step.getCallbackOfType(
              'ValidatedCreatePasswordCallback'
            )
            passwordCallback.setPassword(value)
            document.querySelector('#loader-scripts').classList.add('visible')

            FRAuth.next(step).then((res) => {
              document
                .querySelector('#loader-scripts')
                .classList.remove('visible')
              if (res.type === 'LoginSuccess') {
                document.body.classList.add('pwd-success-temp')
                passwordTyp?.classList.remove('hidden')
                passwordContent?.classList.add('hidden')
                registratiFooter?.classList.add('hidden')
                accediBtn?.addEventListener('click', () => {
                  handleStepLogin(res)
                })
              } else {
                handleStepLogin(res)
              }
            })
          }
        }
      })
      document.querySelector('#loader-scripts').classList.remove('visible')
    },
    Step5PasswordInnerError: (step) => {
      const errorField = document.querySelector('#password-error')
      const errorFieldSpan = document.querySelector('#password-error span')
      errorField.classList.remove('hidden')

      try {
        const VCPC = step.getCallbackOfType('ValidatedCreatePasswordCallback')
        const VcpcFailedPolicies = VCPC.getFailedPolicies()
        if (!!VcpcFailedPolicies.length) {
          errorFieldSpan.innerHTML = getPassFailedMessage(VcpcFailedPolicies)
        }
      } catch (err) {
        console.error(err)
        errorFieldSpan.innerHTML =
          'Si è verificato un errore inatteso, riprova per favore'
      } finally {
        errorField.classList.add('visible')
        document.body.classList.remove('pwd-success-temp')
        document.querySelector('#loader-scripts').classList.remove('visible')
      }
    },
    SocialOrLocal: (step) => {
      const ChoiceCallback = step.getCallbackOfType('ChoiceCallback')
      ChoiceCallback.setInputValue(1)
      nextStep(step)
    },
    LoginStep1: (step) => {
      const name = username
      const pass = password
      document.body.classList.add('login-trying')
      //Raf: retrieve delle callback necessarie
      const nameCallback = step.getCallbackOfType('NameCallback')
      const ValidatedCreatePasswordCallback =
        step.getCallbackOfType('PasswordCallback')
      const SelectIdpCallback = step.getCallbackOfType('SelectIdPCallback')
      SelectIdpCallback.setInputValue('localAuthentication')

      //Raf: ad ogni callback associo l'elemento del DOM
      if (name.match(regexEmail)) {
        nameCallback.setName(name.toLowerCase())
      } else {
        nameCallback.setName(name)
      }
      ValidatedCreatePasswordCallback.setPassword(pass)
      nextStep(step)
    },
    LoginStep1Recaptcha: (step) => {
      const name = username
      const pass = password
      document.body.classList.add('login-trying')
      //Raf: retrieve delle callback necessarie
      const nameCallback = step.getCallbackOfType('NameCallback')
      const ValidatedCreatePasswordCallback =
        step.getCallbackOfType('PasswordCallback')
      //Raf: ad ogni callback associo l'elemento del DOM
      if (name.match(regexEmail)) {
        nameCallback.setName(name.toLowerCase())
      } else {
        nameCallback.setName(name)
      }
      ValidatedCreatePasswordCallback.setPassword(pass)
      const RecaptchaCallback = step.getCallbackOfType('ReCaptchaCallback')
      const siteKey = RecaptchaCallback.getSiteKey()
      const captchaApiUri =
        RecaptchaCallback.getOutputByName('captchaApiUri') +
        '?render=' +
        siteKey
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.onload = function () {
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function () {
          // eslint-disable-next-line no-undef
          grecaptcha
            .execute(siteKey, { action: 'submit' })
            .then(function (token) {
              RecaptchaCallback.setResult(token)
              nextStep(step)
            })
        })
      }
      script.src = captchaApiUri
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    Error: (step) => {
      //@todo ampliare gestione codice errore
      let inputs = document.querySelectorAll('input')
      inputs.forEach((input) => input.classList.add('error'))
      console.log(`step`, step.getMessage())
      document.querySelector('#loader-scripts').classList.remove('visible')
      if (step.getMessage() === 'Failed policy validation') {
        document.querySelector('#password-error').classList.add('visible')
        document.querySelector('#password-error span').innerHTML =
          ERROR_MESSAGES.passPolicyAttributeValue
        return
      }
      let selector = null

      if (
        !window.stepBackup ||
        window.stepBackup.payload.description !== 'OTP_EMAIL'
      ) {
        selector = '#Error'
      } else {
        selector = '#otp-error'
      }

      document.querySelector(selector).classList.add('visible')

      // retrieve previous step callbacks
      const RecaptchaCallback = !!window.stepBackup
        ? window.stepBackup.getCallbacksOfType('ReCaptchaCallback')
        : []
      const stringAttributeInputCallback = !!window.stepBackup
        ? window.stepBackup.getCallbacksOfType('StringAttributeInputCallback')
        : []

      if (step.getMessage().indexOf('Locked Out') > -1) {
        document.querySelector(`${selector} span`).innerHTML =
          ERROR_MESSAGES.userLockedOut
      } else if (
        step.getMessage().indexOf('Login failure') > -1 &&
        RecaptchaCallback.length &&
        stringAttributeInputCallback.length
      ) {
        document.querySelector(`${selector} span`).innerHTML =
          ERROR_MESSAGES.accessDenied
      } else {
        document.querySelector(`${selector} span`).innerHTML =
          ERROR_MESSAGES.wrongPassword
      }
    },
    [FATAL]: (step) => {},
  }

  const handleStepLogin = async (step) => {
    console.log(`step -> ${step.type} => payoload:`, step.payload)
    switch (step.type) {
      case 'LoginSuccess':
        eventDataLayer({
          event: 'process_ok',
          stream: 'web',
          azione: 'login',
          metodo: 'mail',
          sezione: 'login',
        })
        const tokens = await TokenManager.getTokens({
          forceRenew: true,
        })
        window.isUtenteProspect = false
        loginOnNewAuth(tokens.idToken, tokens.accessToken).then((result) => {
          if (result !== 'newAuth') {
            document.body.classList.add('login-success-temp')
            document
              .querySelector('#password-error')
              .classList.remove('visible')
            document.querySelector('#otp-error').classList.remove('visible')
            document.querySelector('#password-error span').innerHTML = ''
            document.querySelector('#otp-error span').innerHTML = ''
            document.cookie =
              'a_ls=' + '1' + '; path=/; domain=.a2a.it; SameSite=None;secure'
            const params = new URLSearchParams(window.location.search)
            let redirectUrlBolletta = params.has('maggiortutela')
              ? process.env.REACT_APP_MERCATO_TUTELA_AUTH
              : process.env.REACT_APP_MERCATO_LIBERO_AUTH

            if (params.has('startURL')) {
              let startUrl = params.get('startURL')
              redirectUrlBolletta =
                redirectUrlBolletta.indexOf('?') > -1
                  ? `${redirectUrlBolletta}&startURL=${startUrl}`
                  : `${redirectUrlBolletta}?startURL=${startUrl}`
            }
            if (params.has('inv')) {
              let inv = params.get('inv')
              redirectUrlBolletta =
                redirectUrlBolletta.indexOf('?') > -1
                  ? `${redirectUrlBolletta}&inv=${inv}`
                  : `${redirectUrlBolletta}?inv=${inv}`
            }
            document
              .querySelector('#loader-scripts')
              .classList.remove('visible')
            window.location.href = redirectUrlBolletta
          } else {
            const params = new URLSearchParams(window.location.search)
            let redirectUrlNewAuth = params.has('maggiortutela')
              ? process.env.REACT_APP_NEW_AREA_MERCATO_TUTELA_AUTH
              : process.env.REACT_APP_NEW_AREA_MERCATO_LIBERO_AUTH

            if (params.has('startURL')) {
              let startUrl = params.get('startURL')
              redirectUrlNewAuth =
                redirectUrlNewAuth.indexOf('?') > -1
                  ? `${redirectUrlNewAuth}&startURL=${startUrl}`
                  : `${redirectUrlNewAuth}?startURL=${startUrl}`
            }
            if (params.has('inv')) {
              let inv = params.get('inv')
              redirectUrlNewAuth =
                redirectUrlNewAuth.indexOf('?') > -1
                  ? `${redirectUrlNewAuth}&inv=${inv}`
                  : `${redirectUrlNewAuth}?inv=${inv}`
            }
            window.location.href = redirectUrlNewAuth
          }
        })

        return

      case 'LoginFailure':
        eventDataLayer({
          event: 'process_ko',
          stream: 'web',
          azione: 'login',
          metodo: 'mail',
          error_type: `error400-failed-login`,
          sezione: 'login',
        })
        document.querySelector('#loader-scripts').classList.remove('visible')
        const message = step.payload.message.toLowerCase()
        console.log(`message`, message)
        if (
          !!step.payload &&
          step.payload.message &&
          step.payload.reason &&
          step.payload.reason === 'Unauthorized' &&
          step.payload.message === 'Failed policy validation'
        ) {
          document.body.classList.remove('pwd-success-temp')
          showStep('Error')
          handlersLogin['Error'](step)
        } else if (message.indexOf('user locked out.') > -1) {
          document.body.classList.remove('pwd-success-temp')
          document.body.classList.add('locked-user')
          window.location.href = `/failed-login${
            window.location.href.indexOf('maggiortutela') > -1
              ? '?maggiortutela=1'
              : ''
          }`
        } else {
          showStep('Error')
          handlersLogin['Error'](step)
        }
        return

      default:
        if (
          document.body.classList.contains('login-trying') &&
          step.payload.description !== 'OTP_EMAIL' &&
          step.payload.callbacks[0].type !==
            'ValidatedCreatePasswordCallback' &&
          step.payload.callbacks[0].type !== 'TextOutputCallback'
        ) {
          document.body.classList.remove('login-trying')
          if (username.length || password.length) {
            document
              .querySelector('#loader-scripts')
              .classList.remove('visible')
          }
        }
        const stage = getStageLogin(step) || FATAL
        if (!showStep(stage)) {
          showStep(FATAL)
          handlersLogin[FATAL](step)
        } else {
          handlersLogin[stage](step)
        }
    }
  }

  const getStageLogin = (step) => {
    // RAF: ottengo tutte le callback che e vedo se lo step le contiene
    const passwordCallbacks = step.getCallbacksOfType('PasswordCallback')
    const stringAttributeInputCallback = step.getCallbacksOfType(
      'StringAttributeInputCallback'
    )
    const SelectIdPCallback = step.getCallbacksOfType('SelectIdPCallback')
    const ValidatedCreatePasswordCallback = step.getCallbacksOfType(
      'ValidatedCreatePasswordCallback'
    )
    const NameCallback = step.getCallbacksOfType('NameCallback')
    const TextOutputCallbacks = step.getCallbacksOfType('TextOutputCallback')
    const ChoiceCallbacks = step.getCallbacksOfType('ChoiceCallback')
    const RecaptchaCallback = step.getCallbacksOfType('ReCaptchaCallback')
    if (ChoiceCallbacks.length === 1) {
      return 'SocialOrLocal'
    }
    if (TextOutputCallbacks.length) {
      // eslint-disable-next-line max-len
      console.log(
        `object`,
        step.getCallbackOfType('TextOutputCallback').payload.output[0].value
      )
      if (
        step
          .getCallbackOfType('TextOutputCallback')
          .payload.output[0].value.indexOf('SAP_MIGRATION_ERROR') > 0
      ) {
        return 'MigrationError4'
      }
    }

    if (
      typeof step.payload.description !== 'undefined' &&
      step.payload.description === 'OTP_EMAIL'
    ) {
      return 'OtpEmailInner'
    }

    // step autenticazione social
    if (
      SelectIdPCallback.length &&
      NameCallback.length &&
      passwordCallbacks.length
    ) {
      return 'LoginStep1'
    }

    // step autenticazione social
    if (
      RecaptchaCallback.length &&
      NameCallback.length &&
      passwordCallbacks.length
    ) {
      return 'LoginStep1Recaptcha'
    }

    // step in cui c'è solo last channel WEB da submittare in automatico con autosubmit
    if (RecaptchaCallback.length && stringAttributeInputCallback.length) {
      return 'StringAttributeInputCallbackRecaptcha'
    }

    // step in cui c'è solo last channel WEB da submittare in automatico con autosubmit
    if (stringAttributeInputCallback.length) {
      return 'StringAttributeInputCallback'
    }

    if (ValidatedCreatePasswordCallback.length > 0) {
      // verifico failed policies per la password
      try {
        const VCPC = ValidatedCreatePasswordCallback.pop()
        const VcpcFailedPolicies = VCPC.getFailedPolicies()
        if (!!VcpcFailedPolicies.length) {
          // failed policies!
          return 'Step5PasswordInnerError'
        }
      } catch (err) {
        console.error(err)
      }
      return 'Step5PasswordInner'
    }

    return undefined
  }

  const nextStep = (step) => {
    window.stepBackup = step
    FRAuth.next(step).then(handleStepLogin)
  }
  /**
   * 3 - ATOS/WEKIT METODO DA RICHIAMARE AL LOGOUT
   */
  const logout = async () => {
    try {
      await FRUser.logout()
      window.location.reload(true)
    } catch (error) {
      console.error(error)
    }
  }
  nextStep()
}
